import images from "../../assets/images/assets";

const SectionImage = () => {
  return (
    <div className="w-full md:w-[64%] h-2/3 mt-4 border border-prime-red  p-4 rounded-t-full relative lg:mt-24 lg:w-[480px] lg:h-[680px] z-[99]">
      <img
        src={images.star1}
        alt="decorative"
        className="absolute -top-3 left-40.5 md:left-50 lg:w-8 lg:-top-5 lg:left-54"
      />
      <div
        style={{ backgroundImage: `url(${images.hero_2})` }}
        className="w-full h-full bg-lime-300 bg-cover rounded-t-full overflow-clip bg-center saturate-120"
      ></div>
    </div>
  );
};

export default SectionImage;
